import React, { useEffect } from 'react';
import Module from '../../../../../layout/Module';
import ChartSelector from './ChartSelector/ChartSelector';
import StudentSelector from './StudentSelector/StudentSelector';
import CurrriculumSelector from './CurriculumSelector/CurrriculumSelector';
import { useByStudent } from '../ByStudentContext/ByStudentContext';
import { updateFilter } from '../../../../../../store/actions/filter.actions';
import { useDispatch } from 'react-redux';
import { updateSkip } from '../../../../../../store/actions/datatable.actions';
import { useParams } from 'react-router-dom';
import LegendLearningGrowth from '../LearningGrowth/Legend';

const HeaderContent = ({ pathname }) => {
  const { isLoadingUser } = useByStudent();
  if (isLoadingUser) return <></>;
  const params = useParams();
  const chartType = params['*'].split('/')[0];
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateFilter('usersClass', {}));
    dispatch(updateSkip('usersClass', 0));
  }, []);

  return (
    <Module.BodyHeader
      gap={2}
      className='border-b border-b-2 border-primary flex justify-start items-center relative'
      py={2}
    >
      <ChartSelector path={pathname} />

      <div
        className='flex justify-start items-center absolute top-0px bottom-0px right-0'
        style={{
          left: 'calc(150px + 1rem)'
        }}
      >
        {['learning-growth'].includes(chartType) && <LegendLearningGrowth />}
        <StudentSelector />
        <CurrriculumSelector />
      </div>
    </Module.BodyHeader>
  );
};

export default HeaderContent;
